import React from "react";
import CustomVideoPlayer from "../../components/VideoPlayer/VideoPlayer";

const Player = () => {
    return (
        <>
            <div>
                <CustomVideoPlayer />
            </div>
        </>
    );
};

export default Player;
